export default __webpack_public_path__ + "static/media/FINE-BNB.b4c0dc49.svg";